import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';


export interface PrintTriggerDialogData {
  title: string;
  function: string;
  postBody: any;
}

export interface PrintTriggerResponse {
  busyPrinting: boolean;
  errorMessage: string;
  printTriggerId: number;
}

@Component({
  selector: 'app-print-trigger-dialog',
  templateUrl: './print-trigger-dialog.component.html',
  styleUrls: ['./print-trigger-dialog.component.scss']
})
export class PrintTriggerDialogComponent implements OnInit {
  integrationBusy: boolean = true;
  printTrigger: PrintTriggerResponse;

  constructor(
    public dialogRef: MatDialogRef<PrintTriggerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PrintTriggerDialogData,
    private baseService: BaseService
  ) { }

  ngOnInit() {
    this.baseService.executeCommand<PrintTriggerResponse>(this.data.function, this.data.postBody)
      .subscribe(
        response => {
          if (response.responseCode === 0) {
            this.printTrigger = response.data;
            this.checkPrintStatus();
          } else {
            this.dialogRef.close(false);
          }
        },
        error => {
          this.dialogRef.close(false);
        });
  }

  checkPrintStatus() {
    this.baseService.executeCommand<PrintTriggerResponse>('portal_print_trigger_check_status', this.printTrigger).subscribe(
      response => {

        if (response.responseCode === 0) {
          this.printTrigger = response.data;
          if (this.printTrigger.busyPrinting) {
            setTimeout(() => {
              this.checkPrintStatus();
            }, 500);
          } else {
            this.integrationBusy = false;
            if (this.printTrigger.errorMessage) {

            } else {
              this.dialogRef.close(response.data.printTriggerId);
            }
          }
        } else {
          this.integrationBusy = false;
          this.printTrigger = {
            busyPrinting: false,
            errorMessage: response.responseMessage,
            printTriggerId: null,
          }
        }
      },
      error => {
        this.dialogRef.close(false);
      });
  }
}
